import { clear, getElementFromString, getEvent } from './functions';
import dayjs from 'dayjs';
import 'element-closest-polyfill';

export default class TableLayout {
    constructor( tables ){
        if( ! tables || ! tables.length ){
            console.warn( 'No tables' );
            return;
        }

        this.tables = tables;
        this.elements = {
            // tables: document.querySelector( '.table--tables' ),
            time: document.getElementById( 'hpy_event_time' ),
            qty: document.querySelector( 'tr.table--qty' ),
            hidden: document.getElementById( 'hpy_event_table_id' ),
            hiddenQty: document.getElementById( 'hpy_event_table_qty' ),
            hiddenMax: document.getElementById( 'hpy_event_table_max' ),
            cart: document.querySelector( 'tr.event--cart' )
        };
        this.state = {
            active: true
        };

        jQuery( document.body )
            .on( 'click', '.event--table_time:not(.empty)', this.chooseTime.bind( this ) )
            .on(' click', '.table--qty .event--table_qty:not(.empty)', this.chooseQty.bind( this ) );
    }

    setupLayout(){
        let children = '';
        const selector = document.querySelector( '.event--time-selector' );

        this.elements.time.parentNode.style.display = 'none';
        [...this.elements.time.children].forEach( child => {
            children += this.getTableTime( child );
        });

        if( selector ) {
            selector.parentNode.replaceChild( getElementFromString( `<div class="event--time-selector">${ children }</div>` ), selector );
        } else {
            this.elements.time.closest('td').insertAdjacentHTML( 'beforeend', `<div class="event--time-selector">${ children }</div>` ); 
        }

        let target = false;

        if( this.elements.time.value ){
            target = document.querySelector(`.event--table_time:not(.empty)[data-time="${ this.elements.time.value }"]`);
        }
        
        if( ! target ){
            target = document.querySelector(`.event--table_time:not(.empty)`);
        }
        
        target.classList.add('active');
        
        const option = [...this.elements.time.children].find( time => time.value === target.dataset.time );
        this.elements.time.value = option.value;
        this.elements.time.dispatchEvent( getEvent('change') );

        this.showQty();
    }

    chooseTime( e ){
        if( ! this.state.active ){
            return;
        }

        [...document.querySelectorAll('.event--table_time')].forEach( time => time.classList.remove('active') );
        const target = e.target.closest('.event--table_time');
        target.classList.add('active');

        
        const option = [...this.elements.time.children].find( time => time.value === target.dataset.time );
        this.elements.time.value = option.value;

        this.elements.time.dispatchEvent( getEvent('change') );

        this.showQty();
    }

    setTimeSelectors(){
        
    }

    destroy(){
        this.state.active = false;
        jQuery( document.body )
            .off( 'click', '.event--table_time', this.chooseTime )
            .off(' click', '.table--qty .event--table_qty', this.chooseQty );
        this.elements.time.parentNode.style.display = 'inline-flex';
        this.elements.qty.classList.remove('visible');
        const selector = document.querySelector( '.event--time-selector' );
        
        if( selector ){
            selector.style.display = 'none';
        }
    }

    getTableTime( time ){
        return `<span class="event--table_time${ time.disabled ? ' empty' : '' }" data-time="${ time.value }">${ dayjs( `2020-1-1 ${ time.value }`, 'YYYY-M-D HH:mm:ss' ).format( 'ha' ) }</span>`;
    }

    getTableQty( qty, tables ){
        return `<span class="event--table_qty ${ tables && ! tables.length ? ' empty' : '' }" data-max="${ tables && tables.length ? tables[tables.length - 1].max : 1 }" data-qty="${ qty }" data-tables='${ tables && tables.length ? tables.map( t => t.id ).join(',') : '' }'>${ qty }</span>`;
    }

    showQty(){
        if( ! this.state.active ){
            return;
        }

        const qtyWrap = this.elements.qty.querySelector('.event--tableQty_wrap');

        clear( qtyWrap );
        let qtys = {};
        this.tables.forEach( table => {
            if( table.min > 0 && table.max > 0 ){
                for( let min = table.min - 1; min < table.max; min++ ){

                    if( ! qtys[min+1] ){
                        qtys[min+1] = [];
                    }

                    if( table.qty <= 0 ) {
                        continue;
                    }

                    qtys[min+1].push( { id: table.id, max: table.max } )
                }
            }
        } );

        for( let q in qtys ){
            qtys[q].sort( (a,b)  => a.max > b.max ? 1 : -1 );
            qtyWrap.insertAdjacentElement( 'beforeend', getElementFromString( this.getTableQty( q, qtys[q] ) ) );
        }

        this.elements.qty.classList.add('visible');

        jQuery('.event--table_qty:first').trigger( 'click' );
    }

    chooseQty( e ){
        [...this.elements.qty.querySelectorAll('.event--table_qty')].forEach( table => {
            table.classList.remove('active');
        });
        const target = e.target.closest('.event--table_qty');
        const qty = document.querySelector('.events--booking input.qty');

        qty.value = target.dataset.qty;
        qty.dispatchEvent(getEvent('change'));

        this.elements.hidden.value = target.dataset.tables ? target.dataset.tables.split(',')[0] : '';
        this.elements.hiddenQty.value = target.dataset.qty ? target.dataset.qty : 1;
        this.elements.hiddenMax.value = target.dataset.max ? target.dataset.max : 1;

        target.classList.add( 'active' );
    }

    tempId(){
        return Math.random().toString(36).substr(3, 6);
    }

    maybeDeactive(){
        const active = this.getActiveTables();
        if( ! active.length ){
            this.elements.cart.classList.remove('visible');
            this.elements.qty.classList.remove('visible');
        }
    }
}